<template>
    <div class="mt-2">
        <b-button variant="primary" @click.stop="confirmarInserirDetalhe()">
            <i class="fa fa-plus mr-2"></i> Inserir detalhes em Lote
        </b-button>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import { situacaoContrato } from '../SituacaoContrato'

export default {
    props: {
        fase: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        confirmarInserirDetalhe() {
            if (!this.contratoElaboracao() && !this.aditivarContrato()) {
                if (this.contratoApostilamento == null) {
                    this.$swal({
                        title: 'O que deseja fazer ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Apostilar',
                        cancelButtonText: 'Atualizar'
                    }).then(result => {
                        if (result.value) {
                            this.alternaJustificativa(
                                result.value == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        } else if (result.isDismissed) {
                            this.alternaJustificativa(
                                result.isConfirmed == true ? 1 : 0
                            )
                            this.mostrarAlerta()
                        }
                    })
                } else if (this.contratoApostilamento == 1) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                } else if (this.contratoApostilamento == 0) {
                    this.alternaJustificativa(this.contratoApostilamento)
                    this.mostrarAlerta()
                }
            } else {
                this.mostrarAlerta()
            }
        },

        mostrarAlerta() {
            this.$swal({
                title: 'Detalhe da Fase do Contrato',
                html: `Confirma a inserção em lote dos detalhes da fase <b>${this.fase.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: `Informe a ${this.labelJustificativa}`,
                inputValidator: value => {
                    if (!value) {
                        return `A justificativa ${this.textoInfoJustificativa} é obrigatória'`
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.inserirDetalhes(result.value)
                }
            })
        },

        inserirDetalhes(justificativa) {
            this.$store.dispatch('addRequest')
            let faseDto = {
                faseContratoId: this.fase.faseContratoId,
                idContrato: this.$route.params.contratoId,
                justificativaApostilamento: justificativa,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.inserirDetalhesFaseParcelaFixa(faseDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.$toast.error(
                                'Falha na inserção dos detalhes em lote',
                                'OK',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Inserção realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterDetalhesFaseAtualizados')
            this.$emit('obterComprometimentosAtualizados')
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido()
            )
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if (this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'justificativa do apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = 'justificativa'
            }
        },

        alternaJustificativaPorAcesso() {
            if (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.$temAcessoView('CONT-APOST-06')
            ) {
                this.contratoApostilamento = null
            } else if (this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if (this.$temAcessoView('CONT-APOST-06')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }
    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {},

    watch: {},

    validations: {}
}
</script>
